import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import { genderTypes } from 'Participant'

class ProfileInfos extends Component {
  state = {
    isValid: true,
    companyName: this.props.participant.companyName,
    cnpj: this.props.participant.cnpj,
    email: this.props.participant.email,
    workPhone: {
      value: `${this.props.participant.phones.work.areaCode}${
        this.props.participant.phones.work.number
      }`,
      disabled: this.props.participant.phones.work.disabled
    },
    mobilePhone: {
      value: `${this.props.participant.phones.mobile.areaCode}${
        this.props.participant.phones.mobile.number
      }`,
      disabled: this.props.participant.phones.mobile.disabled
    }
  }

  componentDidMount () {
    this.isValid()
  }

  isValid = () => {
    let isValid = true
    const mailValidator = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim
    const { companyName, cnpj, email, mobilePhone } = this.state

    if (!companyName.value) {
      this.setState({
        name: {
          value: companyName.value,
          disabled: companyName.disabled,
          error: 'Digite sua Razão Social'
        }
      })
      isValid = false
    }

    if (!cnpj.value) {
      this.setState({
        cnpj: {
          value: cnpj.value,
          disabled: cnpj.disabled,
          error: 'Digite um CNPJ válido'
        }
      })
      isValid = false
    }

    if (!mailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          disabled: email.disabled,
          error: 'Digite um e-mail válido'
        }
      })
      isValid = false
    }

    if (!mobilePhone.value) {
      this.setState({
        mobilePhone: {
          value: mobilePhone.value,
          disabled: mobilePhone.disabled,
          error: 'Digite um celular válido'
        }
      })
      isValid = false
    }
    this.setState({ isValid })
    return isValid
  }

  handleConfirm = () => {
    if (!this.isValid()) return

    const { companyName, cnpj, email, workPhone, mobilePhone } = this.state
    const customer = {
      name: companyName.value,
      documentNumber: cnpj.value,
      email: email.value,
      genderType: genderTypes[this.props.participant.genderType.value],
      personType: 'COMPANY',
      phones: [
        this.props.buildPhone(workPhone.value, 'WORK'),
        this.props.buildPhone(mobilePhone.value, 'MOBILE')
      ]
    }
    this.props.setCustomer(customer)
  }

  handleInputValid (input) {
    if (input.error) return false

    return null
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: { value: event.target.value }
    })
  }

  handleKeyPress = (e, element) => {
    let inputIndex = element
    const inputOrder = [
      'input-name-profile-data',
      'input-cnpj-profile-data',
      'input-email-profile-data',
      'input-mobilePhone-profile-data',
      'input-workPhone-profile-data',
      'company-next'
    ]

    let isDisabled = true

    while (isDisabled) {
      if (inputOrder[inputIndex] === 'company-next') {
        isDisabled = false
      } else {
        let input = document.querySelector(`#${inputOrder[inputIndex]}`)
        if (input.getAttribute('disabled') === null || input.getAttribute('disabled') === undefined) {
          isDisabled = false
        } else {
          inputIndex++
        }
      }
    }

    // eslint-disable-next-line no-unused-expressions
    if (e.key === 'Enter') {
      if (inputIndex) {
        e.target.blur()
        document.querySelector(`#${inputOrder[inputIndex]}`) &&
          document.querySelector(`#${inputOrder[inputIndex]}`).focus()
      }
    }
  }

  render () {
    return (
      <div className='row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'>
        <div className='profile-infos col-12 px-2'>
          <div className='row mx-0'>
            <Input
              id='input-name-profile-data'
              label='Razão social'
              className='col-12 col-md-6 mt-2'
              minLength='1'
              maxLength='100'
              name='companyName'
              required
              data-error={this.state.companyName.error}
              valid={this.handleInputValid(this.state.companyName)}
              onChange={this.handleInputChange}
              value={this.state.companyName.value}
              disabled={this.state.companyName.disabled === 'true'}
              onKeyPress={(e) => this.handleKeyPress(e, 1)}
              onBlur={this.isValid}
            />

            <Input
              id='input-cnpj-profile-data'
              label='CNPJ'
              className='col-12 col-md-6 mt-2'
              required
              mask={[
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '/',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/
              ]}
              name='cnpj'
              data-error={this.state.cnpj.error}
              valid={this.handleInputValid(this.state.cnpj)}
              onChange={this.handleInputChange}
              onKeyPress={(e) => this.handleKeyPress(e, 2)}
              value={this.state.cnpj.value}
              disabled={this.state.cnpj.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-email-profile-data'
              label='E-mail'
              className='col-12 col-md-6 mt-2'
              required
              name='email'
              data-error={this.state.email.error}
              valid={this.handleInputValid(this.state.email)}
              onChange={this.handleInputChange}
              value={this.state.email.value}
              onKeyPress={(e) => this.handleKeyPress(e, 3)}
              disabled={this.state.email.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-mobilePhone-profile-data'
              label='Celular'
              className='col-12 col-md-6 mt-2'
              required
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              data-error={this.state.mobilePhone.error}
              valid={this.handleInputValid(this.state.mobilePhone)}
              onChange={this.handleInputChange}
              name='mobilePhone'
              value={this.state.mobilePhone.value}
              disabled={this.state.mobilePhone.disabled === 'true'}
              onBlur={this.isValid}
              onKeyPress={(e) => this.handleKeyPress(e, 4)}
            />

            <Input
              id='input-workPhone-profile-data'
              label='Telefone comercial'
              className='col-12 col-md-6 mt-2'
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              name='workPhone'
              onChange={this.handleInputChange}
              value={this.state.workPhone.value}
              disabled={'' + this.state.workPhone.disabled === 'true'}
              onBlur={this.isValid}
              onKeyPress={(e) => this.handleKeyPress(e, 5)}
            />

            <div className='col-12 col-md-6 mt-2'>
              <Button
                id='company-next'
                className='btn btn-sm btn-featured'
                disabled={!this.state.isValid}
                onClick={() => {
                  this.handleConfirm()
                  this.props.forceFocus()
                }
                }
                text='Próximo'
              />
            </div>

            <div className='float-button bg-white px-2 py-2 row mx-0 d-none'>
              <div className='col-12 px-0'>
                <Button
                  className='btn btn-sm btn-sm btn-featured'
                  disabled={!this.state.isValid}
                  onClick={() => {
                    this.handleConfirm()
                    this.props.forceFocus()
                  }
                  }
                  text='Próximo'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired
})

ProfileInfos.propTypes = {
  participant: PropTypes.shape({
    companyName: valueType,
    cnpj: valueType,
    email: valueType,
    phones: PropTypes.object,
    genderType: PropTypes.object
  }).isRequired,
  setCustomer: PropTypes.func.isRequired,
  buildPhone: PropTypes.func.isRequired,
  forceFocus: PropTypes.func.isRequired
}

export default ProfileInfos



// WEBPACK FOOTER //
// ./src/features/Checkout/ProfileInfos/Company.js